import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Typography,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  WhatshotIcon,
  FormHelperText,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  commonService,
  Radio,
  OutlinedInput,
  FormControlLabel,
  RadioGroup,
} from "../../../common";

const urlParams = new URLSearchParams(window.location.search);
const level_id = urlParams.get("update_id");
const level_name = urlParams.get("name");

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3rem",
    padding: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  formLabel: {
    color: "#2B335E",
    fontSize: "1.25rem",
    letterSpacing: "0.014375rem",
    margin: "0 0 0 0.75rem",
  },
  error: {
    color: "#FF0F0F",
  },
  radioBtnStyle: {
    border: "1px solid #BEBDBD",
    width: "100%",
    borderRadius: "5px",
    margin: "0 0 0 -1px",
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  btnContainer: {
    paddingTop: "5rem",
  },
  divider: {
    marginTop: "3rem",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GreenRadio = withStyles({
  root: {
    color: "#BEBDBD",
    "&$checked": {
      color: "#FC2861",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
let totalInputLengthArr = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];
export default function LevelCreate() {
  const classes = useStyles();
  const [name, setName] = useState(level_name || "");

  const [userTypeList, setUserTypeList] = useState([]);
  const [userType, setUserType] = useState("");
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [transactionType, setTransactionType] = useState("");
  const [currency, setCurrency] = useState("20");
  const [level, setLevel] = useState("");
  const [levelTypeList, setLevelTypeList] = useState([]);
  const [maxNoOfTransaction, setMaxNoOfTransaction] = useState("");
  const [limitType, setLimitType] = useState("");
  const [totalTransactionAmount, setTotalTransactionAmount] = useState("");
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [limitTypeList, setLimitTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  // const [selectedRadioVal, setSelectedRadioVal] = React.useState(false);
  const [remainingInputfield, setRemainingInputfield] = React.useState(8);
  const [totalInputfield, setTotalInputfield] = React.useState(8);
  //const [radioSelectionStyle, setRadioSelectionStyle] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    const info = {
      name: name,
    };
    setLoading(true);
    if (handleError()) {
      const res = await commonService.createLevel(info);
      console.log("response");
      res?.code === 200 && setOpen(true);
      setLoading(false);
      setSuccessMsgBody("Successfully Added.");
      clearFormInput();

      res?.code !== 200 && setError(true);
      setLoading(false);
      setErrorMsgBody(res.messages[0]);
    } else {
      timer.current = window.setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleUpdate = async () => {
    const info = {
      id: level_id,
      name: name,
    };
    setLoading(true);
    if (handleError()) {
      const res = await commonService.updateLevel(info);
      console.log("response");
      res?.code === 200 && setOpen(true);
      setLoading(false);
      setSuccessMsgBody("Successfully Updated.");

      res?.code !== 200 && setError(true);
      setLoading(false);
      setErrorMsgBody(res.messages[0]);
    } else {
      timer.current = window.setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleError = () => {
    let formIsValid = true;
    let errors = {};
    if (name === "") {
      formIsValid = false;
      errors["name"] = "Name can't left empty.";
    }

    setErrors(errors);
    return formIsValid;
  };

  const onChangeLimitType = (e) => {
    // console.log('e', e);
    // console.log('e', e.target.id);
    // let getids = document.getElementById(e.target.id);
    // let getRadiogroup = document.getElementsByClassName('limitTypeRadioGroup');

    // console.log('getids', getids);
    // console.log('getRadiogroup', getRadiogroup);

    // console.log('e', e.target.offsetParent.parentElement);
    // e.target.offsetParent.parentElement.className = 'radioChecked';

    if (e.target.value !== "") {
      if (totalInputLengthArr[6] == false) {
        totalInputLengthArr[6] = true;
        setRemainingInputfield(remainingInputfield - 1);
      }
    }

    setLimitType(e.target.value);
    setErrors({});
  };

  const clearFormInput = () => {
    setName("");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const timer = React.useRef();

  const getUserTyps = async () => {
    const userTypeList = await commonService.getUserType();
    setUserTypeList(userTypeList.data?.user_types);
  };

  const getCurrenciess = async () => {
    const currency = await commonService.getCurrencies();
    setCurrencyList(currency.data?.currencies);
  };

  const getLimitTypes = async () => {
    const limitType = await commonService.getLimitType();
    setLimitTypeList(limitType.data?.limit_types);
  };

  useEffect(() => {
    getUserTyps();
    getCurrenciess();
    getLimitTypes();

    // var totalinputFieldLength = document.getElementsByClassName(
    //   'MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6'
    // ).length;
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const getTransactionTypeList = async (sender) => {
    const transactionType = await commonService.getTransactionTypeLimit(sender);
    setTransactionTypeList(transactionType.data?.transaction_types);
  };

  const getLevelsList = async (user_type_id) => {
    const levelType = await commonService.getLevel(user_type_id);
    setLevelTypeList(levelType.data?.levels);
  };

  return (
    <Grid xl={12} container className={classes.root}>
      {/* {console.log('totalInputLengthArr', totalInputLengthArr)} */}
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Grid item xl={12}>
        <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
          <NavLink color="inherit" to="/dashboard" className={classes.link}>
            <HomeIcon className={classes.icon} />
            Home
          </NavLink>
          <NavLink color="inherit" to="/level" className={classes.link}>
            <WhatshotIcon className={classes.icon} />
            Level
          </NavLink>
          <Typography color="textPrimary" className={classes.link}>
            Create
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              textAlign: "left",
              margin: "15px 0",
              color: "#2B335E",
              fontSize: "25px",
            }}
          >
            Create Limit
          </Typography>

          <NavLink
            to="/level"
            variant="contained"
            style={{ height: "30px", textDecoration: "none" }}
          >
            <Typography
              style={{
                color: "#2B335E",
                fontSize: "18px",
              }}
            >
              View Level List
            </Typography>
          </NavLink>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper style={{ padding: "20px", textAlign: "left" }}>
          <Grid container spacing={2}>
            <Grid item xs="12">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                   Level Name
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <OutlinedInput
                      value={name}
                      name="name"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    ></OutlinedInput>
                    <FormHelperText className={classes.error}>
                      {errors["name"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xl={12}
              md={12}
              sm={12}
              xs={12}
              lg={12}
              justify="space-between"
              alignItems="center"
              className={classes.divider}
            >
              {" "}
              <Divider style={{ margin: "20px 0", color: "#00000029" }} />
            </Grid>

            <Grid
              item
              container
              xl={12}
              justify="space-between"
              alignItems="center"
              className={classes.btnContainer}
            >
              <Grid item xl={6} md={6} sm={6} xs={6} lg={6}>
                <Box ml={1}></Box>
              </Grid>
              <Grid
                item
                container
                xl={6}
                md={6}
                sm={6}
                xs={6}
                lg={6}
                justify="flex-end"
                alignItems="center"
              >
                <Box mr={5}>
                  <Button
                    variant="contained"
                    className={classes.cancelBtn}
                    onClick={clearFormInput}
                  >
                    CANCEL
                  </Button>
                </Box>
                <Box mr={1}>
                  {level_id ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleUpdate}
                      disabled={loading}
                      className="btn btn-primary btn-block"
                    >
                      {loading && <CircularProgress size={17} />}
                      Update
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleSubmit}
                      disabled={loading}
                      className="btn btn-primary btn-block"
                    >
                      {loading && <CircularProgress size={17} />}
                      Create & add another
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
